/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { QuestionEvaluationScopeFilter } from './questionEvaluationScopeFilter';


export interface QuestionEvaluationIncludeFilterItems { 
    relation?: QuestionEvaluationIncludeFilterItems.RelationEnum;
    scope?: QuestionEvaluationScopeFilter;
}
export namespace QuestionEvaluationIncludeFilterItems {
    export type RelationEnum = 'competence' | 'relationTypes';
    export const RelationEnum = {
        Competence: 'competence' as RelationEnum,
        RelationTypes: 'relationTypes' as RelationEnum
    };
}


